export default __webpack_public_path__ + "static/media/NEAR_PROTOCOL.531a8736.png";